import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ICustomSetting, IUserCustomSetting } from '@app/shared/models/settings.model';
import { SubscriberComponent } from '@app/shared/modules/subscriber/base/subscriber.component.base';
import { UserContext } from '@app/shared/services/context/user.context.service';
import { CustomerCareService } from '@app/shared/services/cx/customer-care.service';
import { AuthService } from '@auth0/auth0-angular';
import { combineLatest, distinctUntilChanged, forkJoin, map, Observable, tap } from 'rxjs';

@Component({
  selector: 'app-user-config',
  templateUrl: './user-config.component.html',
  styleUrls: ['./user-config.component.sass'],
})
export class UserConfigComponent extends SubscriberComponent implements OnInit, OnDestroy {
  form = new FormGroup({});
  configs: ICustomSetting[] = [];
  configs$!: Observable<ICustomSetting[]>;

  private userEmail = '';

  constructor(
    private readonly _customerCareSvc: CustomerCareService,
    private readonly _authSvc: AuthService,
    private readonly _userCtxt: UserContext
  ) {
    super();
  }

  ngOnInit(): void {
    this.getUserEmail();
    this.getAllSettings();
  }

  private getUserEmail() {
    this._subscriptions.sink = this._authSvc.user$
      .pipe(
        tap(res => {
          this.userEmail = res?.email || '';
        })
      )
      .subscribe();
  }

  private getAllSettings() {
    const settings$ = this._customerCareSvc
      .getAllSettings()
      .pipe(map(res => res.map(item => ({ ...item, label: item.code.toUpperCase() }))));

    this._subscriptions.sink = settings$.subscribe(customSettings => {
      if (customSettings.length > 0) {
        const userCustomSettings = this._userCtxt.configurations();
        this.createFieldDynamics(customSettings, userCustomSettings);
      }
    });
  }
  private createFieldDynamics(configs: ICustomSetting[], userConfigs: IUserCustomSetting[]) {
    //create config fields programatically
    configs.forEach(item => {
      const userConfig = userConfigs.find(element => element.code === item.code);
      const value = userConfig?.value === 'true';
      this.form.addControl(String(item.id), new FormControl(value));
    });

    this.configs = configs; //this configs help to render html fields

    //save the config changes in memory using behavioral subject
    this._subscriptions.sink = this.form.valueChanges.subscribe(formValues => {
      const result: IUserCustomSetting[] = Object.entries(formValues).map(([key, value]) => ({
        id: Number(key),
        value: String(value),
        email: this.userEmail,
        code: configs.find(item => item.id === Number(key))?.code,
      }));

      this._userCtxt.setConfigurations(result);
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }
}
